/* =========================================================
   A2C Museum Floor Plan — Shopify section script
   Small and safe. The room cards are normal links, so no
   JavaScript is required for them to work. This file just
   marks the section as ready (useful hook) and does nothing
   that could affect the rest of your theme.
   ========================================================= */
(function () {
  "use strict";
  var roots = document.querySelectorAll(".a2c-root");
  for (var i = 0; i < roots.length; i++) {
    roots[i].setAttribute("data-a2c-ready", "true");
  }
})();
